module.exports = __webpack_public_path__ + "static/media/autonet.f6555337.gif";